import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

import { BlankHeaderCell } from './BlankHeaderCell';
import { TextHeaderCell } from './TextHeaderCell';

export function DomainTableHeader() {
    return (
        <tbody>
            <tr>
                <TextHeaderCell testId={'domain-header'} text={Messages.dataConnectSiteSettingsDomain()} />
                <TextHeaderCell testId={'pool-header'} text={Messages.dataConnectSiteSettingsPool()} />
                <BlankHeaderCell />
            </tr>
        </tbody>
    );
}

export const domainTableHeadersLine = style({
  height: CommonStyles.Sizes.DataGridHeaderHeight,
  borderBottomWidth: CommonStyles.Sizes.LineWidth,
  borderBottomColor: CommonStyles.Colors.DividerLineColor,
  borderBottomStyle: 'solid',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  backgroundColor: CommonStyles.Colors.White,
  borderSpacing: 0
});
